import React from "react";
import Widget from "./Widget";
import _ from "lodash";

import { config } from "../../state/course-config";

import PeerReview from "./peer-review";
import PeerReviewFeedback from "./PeerReviewFeedback";

const Essay = props => {
  const showFeedback =
    props.confirmed &&
    props.submitted &&
    _.get(props.peerReviewsGiven, "length") >=
      config.MINIMUM_PEER_REVIEWS_GIVEN &&
    _.get(props.peerReviewsReceived, "length") >=
      config.MINIMUM_PEER_REVIEWS_RECEIVED;

  return (
    <div>
      {props.quiz ? (
        <div>
          <Widget
            {...props}
            onChange={value => props.onEssayChange(value)}
            onSubmit={() => props.onSubmit()}
          />
          {showFeedback ? (
            <PeerReviewFeedback
              quiz={props.quiz}
              peerReviewsReceived={props.peerReviewsReceived}
            />
          ) : null}
          {props.submitted ? (
            <PeerReview
              {...props}
              receivePeerReview={data => props.onReceivePeerReview(data)}
              onSubmitPeerReview={data => props.onSubmitPeerReview(data)}
            />
          ) : null}
        </div>
      ) : (
        "Loading"
      )}
    </div>
  );
};

export default Essay;
